import {areDatesEqual} from '@Utils/date.util';

const MIN_SCHEDULE_MINUTES_FROM_NOW = 15;

export const getMinAllowedScheduleDate = (): Date => {
  const minAllowedDate = new Date();
  minAllowedDate.setMinutes(minAllowedDate.getMinutes() + MIN_SCHEDULE_MINUTES_FROM_NOW);

  return minAllowedDate;
};

export enum BestTimeCalculationState {
  OFF = 'off',
  CALCULATING = 'calculating',
  DONE = 'done',
  ERROR = 'error',
}

export enum ScheduleDateChangeEffect {
  NONE = 'none',
  RECOMPUTE_BEST_TIME = 'recompute_best_time',
  DISABLE_BEST_TIME = 'disable_best_time',
}

export function isBestTimeResolving(bestTimeState: BestTimeCalculationState): boolean {
  return bestTimeState === BestTimeCalculationState.CALCULATING;
}

/** Changing the day recomputes best time; editing the time overrides it, so best time switches off. */
export function getScheduleDateChangeEffect(next: Date, current: Date, bestTimeState: BestTimeCalculationState): ScheduleDateChangeEffect {
  if (next.getTime() === current.getTime()) {
    return ScheduleDateChangeEffect.NONE;
  }

  const isBestTimeActive = bestTimeState === BestTimeCalculationState.DONE || isBestTimeResolving(bestTimeState);

  if (isBestTimeActive && !areDatesEqual(next, current)) {
    return ScheduleDateChangeEffect.RECOMPUTE_BEST_TIME;
  }

  return ScheduleDateChangeEffect.DISABLE_BEST_TIME;
}

export function formatOptimalSendTime(date: Date): string {
  const datePart = date.toLocaleDateString('en-US', {month: 'short', day: 'numeric'});
  const timePart = date.toLocaleTimeString('en-US', {hour: '2-digit', minute: '2-digit', hour12: true});

  return `${datePart}, ${timePart}`;
}
